import { Alert } from '@superdispatch/ui-lab';
import { Stack } from '@superdispatch/ui';
import { Link, Typography } from '@material-ui/core';

export function ExpediteApprovalBanner() {
  return (
    <Alert severity="info">
      <Stack space="none">
        <Typography variant="h5">Want to expedite your approval?</Typography>

        <Typography>
          Have your insurance agent send the COI to{' '}
          <Link href="mailto:compliance@superdispatch.com" color="primary">
            compliance@superdispatch.com
          </Link>
          , listing Super Dispatch as the certificate holder. Then upload the
          updated COI below.
        </Typography>
      </Stack>
    </Alert>
  );
}
